import * as FormValidation from 'formvalidation';
import Bootstrap from 'formvalidation/dist/es6/plugins/Bootstrap';

$(document).ready(function () {
    const form = document.getElementById('form-vehicle-contact');
    if (form !== null) {
        FormValidation.formValidation(form, {
            fields: {
                'lead_vehicle[lead][gender]': {
                    validators: {
                        notEmpty: {
                            message: "La civilité est obligatoire."
                        }
                    }
                },
                'lead_vehicle[lead][lastname]': {
                    validators: {
                        notEmpty: {
                            message: "Nom obligatoire."
                        },
                        stringLength: {
                            max: 80,
                            message: 'Maximum de 80 caractères.'
                        },
                    }
                },
                'lead_vehicle[lead][firstname]': {
                    validators: {
                        notEmpty: {
                            message: "Prénom obligatoire."
                        },
                        stringLength: {
                            max: 80,
                            message: 'Maximum de 80 caractères.'
                        },
                    }
                },
                'lead_vehicle[lead][phone]': {
                    validators: {
                        notEmpty: {
                            message: "Le téléphone est obligatoire."
                        },
                        stringLength: {
                            max: 10,
                            min: 10,
                            message: 'Le téléphone doit contenir 10 caractères.'
                        },
                    }
                },
                'lead_vehicle[lead][email]': {
                    validators: {
                        notEmpty: {
                            message: "L'adresse email est obligatoire."
                        },
                        emailAddress: {
                            message: "N'est pas une adresse mail valide."
                        }
                    }
                },
                'lead_vehicle[lead][zipcode]': {
                    validators: {
                        notEmpty: {
                            message: "Le code postal est obligatoire."
                        }
                    }
                },
                'lead_vehicle[lead][city]': {
                    validators: {
                        notEmpty: {
                            message: "La ville est obligatoire."
                        }
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new Bootstrap(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                /*icon: new FormValidation.plugins.Icon({
                    valid: 'fa fa-check',
                    invalid: 'fa fa-times',
                    validating: 'fa fa-refresh'
                }),*/ //Avec Bootstrap 4, ne pas oublier d'importer une fontIcons
                // declarative
                declarative: new FormValidation.plugins.Declarative({html5Input: true})
            }
        });
    }
});




// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/vehicle/contact-vehicle.js